const container = document.querySelector('.list-template');
const config = JSON.parse(container.dataset.obj);
console.log(config);
console.log(container);

const wrapper = document.querySelector('.list-template__wrapper');
const loadMoreBtn = document.querySelector('.list-template__load-more');
const searchInput = document.querySelector('.list-template__search-wrap input');
const counter = document.querySelector('.list-template__counter')
const html = document.querySelector('html')
const firstId = wrapper.getAttribute('data-first')
let page = 1;
let maxPages = 1;
let currentCategory = 'all';
let currentSearch = '';
let debounceTimer = null;


async function fetchLists({ reset = false } = {}) {
  const emptyItems = document.querySelectorAll('.list-template__item-empty')
  const formData = new FormData();
  formData.append('action', 'get_list');
  formData.append('page', page);
  formData.append('search', currentSearch);
  formData.append('category', currentCategory);
  formData.append('post_type', config.postType);
  formData.append('taxonomy', config.taxonomy);
  formData.append('firstId', firstId);

  const res = await fetch(myajax.url, {
    method: 'POST',
    body: formData
  });

  const data = await res.json();
  loadMoreBtn.classList.remove('disable')
  emptyItems.length && emptyItems.forEach(item => {
    item.remove()
  })

  if (data.success) {
    if (reset) {
      wrapper.innerHTML = data.data.html;
    } else {
      wrapper.insertAdjacentHTML('beforeend', data.data.html);
    }

    maxPages = data.data.max_pages;
    if (counter) {
      counter.textContent = `(${data.data.count} items)`;
    }

    if (page >= maxPages) {
      loadMoreBtn.style.display = 'none';
    } else {
      loadMoreBtn.style.display = 'block';
    }
  }
}

loadMoreBtn.addEventListener('click', () => {
  loadMoreBtn.classList.add('disable')
  page++;
  fetchLists();
});


searchInput.addEventListener('input', (e) => {
  clearTimeout(debounceTimer);

  debounceTimer = setTimeout(() => {
    currentSearch = e.target.value;
    page = 1;

    fetchLists({ reset: true });
  }, 400);
});


document.addEventListener('select:change', (e) => {

  if (e && e.detail && e.detail.select && e.detail.select.classList.contains('list-template__sort-wrap')) {
    currentCategory = e.detail.value;
    page = 1;
    fetchLists({ reset: true });
  }
});